import {Component, EventEmitter, HostBinding, Input, Output} from '@angular/core';
import {GetPoomsaTxt} from "../../defines/gukeo.func";
import {Word} from "../../models/word.model";
import {WORD_LIST_MEANING} from "../../defines/desktop.const";

@Component({
  selector: 'app-link-popup-item-word',
  templateUrl: './link-popup-item-word.component.html',
  styleUrls: ['./link-popup-item.component.scss'],
})
export class LinkPopupItemWordComponent {
  @HostBinding('style.display') styleBlock = 'block';
  @HostBinding('class') class = 'tooltip-item';
  @Input() word?: Word;
  @Input() btnClose: boolean = false; // 닫기 버튼 표시 여부
  @Input() dispTxt?: string;
  @Output() close = new EventEmitter<string | null>();

  protected readonly GetPoomsaTxt = GetPoomsaTxt;

  protected onGotoDetail($event: MouseEvent): void {
    $event.stopPropagation();
    $event.preventDefault();
    this.close.emit(this.word?.id);
  }

  protected onClose($event: MouseEvent): void {
    $event.stopPropagation();
    $event.preventDefault();
    this.close.emit(null);
  }

  /**
   * 링크 표시어와 동일한 관련어가 있다면 반환한다.
   * @param word
   * @protected
   */
  protected getDerivative(word: Word): string | null {
    const derivative = word.derivative?.find(d => d === this.dispTxt);
    return derivative ?? null;
  }

  protected getDefaultMeaning(word: Word): string | null {
    return word?.meaning?.[0] ?? null;
  }

  protected getNumberedMeanings(word: Word): Array<string> | null {
    return word?.meaning?.slice(1, WORD_LIST_MEANING + 1) ?? null;
  }

  protected getMoreMeanings(word: Word): number {
    // const more = Math.max(0, (word?.meaning?.length ?? 0) - WORD_LIST_MEANING - 1)
    // console.warn('getMoreMeanings() ', more);
    return Math.max(0, (word?.meaning?.length ?? 0) - WORD_LIST_MEANING - 1);
  }

}
